import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

firebase.initializeApp(process.env.VUE_APP_FIREBASE);

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const emailAuth = firebase.auth.EmailAuthProvider;

export default { db, auth, storage, emailAuth};
